import React from 'react';
import { Box } from '../Box';
import { useFlexClasses } from './useFlexClasses';
import { useTheme } from '../../../theme';
import { join } from '../../../utils/className';
/**
 * Flexbox layout component. `Flex` composes the `Box` component. By default, it renders a `div` element.
 * You can use the `tag` prop to change the element render, just like `as` prop from styled-components.
 *
 * @see https://fe-docs.int.getresponse.com/gr-ui-neo/index.html?path=/docs/layout-flex--flexbox-grid#flex
 */
export const Flex = React.forwardRef(({ alignItems, flexDirection, flexWrap, alignContent, justifyContent, gap, className, inline, flexFlow, ...props }, ref) => {
    const theme = useTheme();
    const classes = useFlexClasses({
        theme,
        alignItems,
        flexDirection,
        flexWrap,
        alignContent,
        justifyContent,
        gap,
        flexFlow,
    });
    const flexDisplay = inline ? 'inline-flex' : 'flex';
    return (React.createElement(Box, { ref: ref, display: props.display || flexDisplay, className: join(className, classes.flex), ...props }));
});
